export default "__VITE_ASSET__DeEgF300__"